




















import { Cadastros, DashboardService } from "@/services/dashboard.service";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import ChartBar from "@/shared/components/chart-bar.vue";
import { ticks, title } from "@/shared/utils/chart";
import GraficoMarketing from "../GraficoMarketing.vue";
import dayjs from "dayjs";

@Component({
  components: { ChartBar, GraficoMarketing },
})
export default class GraficoCadastrosMarketingCard extends Vue {
  readonly options: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,

    tooltips: {
      mode: "index",
      callbacks: {
        //Callback para montar o titulo do tooltip
        footer: (tooltipItems) => {
          const total = tooltipItems.reduce((a, e) => a + parseInt(e.yLabel!.toString()), - parseInt(tooltipItems[2].yLabel!.toString()));
          return 'TOTAL: ' + total;
        },
        title: title("MMM [d]e YYYY"),
      },
    },
    scales: {
      yAxes: [
        {
          stacked: true,
          ticks: {
            precision: 0,
            beginAtZero: true,
          },
        },
      ],
      xAxes: [
        {
          stacked: true,
          ticks: {
            callback: ticks("MMM"),
          },
        },
      ],
    },
  };

  loading = false;
  cadastros: Cadastros[] | null = null;

  @Prop() date!: string | null;
  anoAtual: string | null = null;

  get labels() {
    return this.cadastros!.map((x) => x.data);
  }

  get dataSets(): Chart.ChartDataSets[] {
    return [
      {
        label: "APP",
        backgroundColor: "#FF5777",
        data: this.cadastros?.map((x) => x.quantidadeApp ?? 0),
      },
      {
        label: "SITE",
        backgroundColor: "#5BBFE8",
        data: this.cadastros?.map((x) => x.quantidadeSite ?? 0),
      },
      {
        label: "MÉDIA",
        data: this.obterMedia(),
        backgroundColor: "rgba(229, 229, 234, 0.4)",
        type: "line",
        lineTension: 0,
      },
      
    ];
  }

  obterTotal() {
    const filter = this.cadastros!.filter(
      (item) => (item.quantidadeSite ?? 0 > 0) || (item.quantidadeApp ?? 0 > 0)
    );
    const total = +(filter ?? [])
      .map(
        (x) =>
          ((x.quantidadeSite ?? 0) + (x.quantidadeApp ?? 0))
      )
      .reduce((total, i) => total + i)
      .toFixed(2);
    return this.cadastros?.map(() => total);
  }

  obterMedia() {
    const filter = this.cadastros!.filter(
      (item) => (item.quantidadeSite ?? 0 > 0) || (item.quantidadeApp ?? 0 > 0)
    );
    const media = +(filter ?? [])
      .map(
        (x) =>
          ((x.quantidadeSite ?? 0) + (x.quantidadeApp ?? 0)) / filter.length
      )
      .reduce((total, i) => total + i)
      .toFixed(2);
    return this.cadastros?.map(() => media);
  }

  mounted() {
    this.fetch();
  }

  @Watch("date")
  fetch() {
    if (!this.date) {
      this.anoAtual = dayjs().format("YYYY");
    } else {
      this.anoAtual = dayjs(this.date).format("YYYY");
    }
    dayjs.locale("pt-br");

    this.carregarCadastros();
  }

  async carregarCadastros() {
    this.loading = true;
    if (this.anoAtual) {
      this.cadastros = await DashboardService.CadastrosMes(
        this.anoAtual
      ).finally(() => (this.loading = false)
      );
    }
  }
}
